export default "__VITE_ASSET__BejHkYs___"